<button
  [title]="title || label"
  [disabled]="disabled"
  [ngClass]="classes"
  [type]="type"
  class="btn"
>
  <span
    *ngIf="loading"
    class="spinner-border spinner-border-sm"
    role="status"
  ></span>
  {{ label }}

  <i-feather *ngIf="iconName" [name]="iconName"></i-feather>
</button>
